import { isObject } from '@guardian/libs';
import { getOptionsHeadersWithOkta, } from '../../lib/identity';
import { fetchJson } from './fetchJson';
export const syncDataFromUserBenefitsApi = async (signedInAuthStatus) => {
    const url = window.guardian.config.page.userBenefitsApiUrl;
    if (!url) {
        throw new Error('userBenefitsApiUrl is not defined');
    }
    const response = await fetchJson(url, {
        mode: 'cors',
        ...getOptionsHeadersWithOkta(signedInAuthStatus),
    });
    if (!validateResponse(response)) {
        throw new Error('invalid response');
    }
    return {
        hideSupportMessaging: response.benefits.includes('hideSupportMessaging'),
        adFree: response.benefits.includes('adFree'),
        allowRejectAll: response.benefits.includes('allowRejectAll'),
    };
};
const validateResponse = (response) => {
    return isObject(response) && Array.isArray(response.benefits);
};
